module.exports = __webpack_public_path__ + "static/img/7.575ffc1a.png";